import { render, staticRenderFns } from "./PerspectiveShelf.vue?vue&type=template&id=124bf5b0&scoped=true&"
import script from "./PerspectiveShelf.vue?vue&type=script&lang=js&"
export * from "./PerspectiveShelf.vue?vue&type=script&lang=js&"
import style0 from "./PerspectiveShelf.vue?vue&type=style&index=0&id=124bf5b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124bf5b0",
  null
  
)

export default component.exports